var _g, _g2, _g3, _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 870,
    height: 870,
    viewBox: "0 0 870 870",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(36.25)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,1c1.1,0,2,0.9,2,2v18c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V3c0-1.1,0.9-2,2-2H21 M21,0H3C1.34,0,0,1.34,0,3v18  c0,1.66,1.34,3,3,3h18c1.66,0,3-1.34,3-3V3C24,1.34,22.66,0,21,0L21,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(279,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(327,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(423,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(543,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(567,87) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(327,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(351,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(447,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(471,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(495,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,111) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(279,135) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(327,135) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(351,135) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(375,135) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(399,135) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(447,135) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(303,159) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(351,159) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(375,159) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,159) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(423,159) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(495,159) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(303,183) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(423,183) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(471,183) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,183) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,183) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(567,183) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,207) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(375,207) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(471,207) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(327,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(375,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(423,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(471,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(519,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,231) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(303,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(327,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(351,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(423,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(447,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(567,255) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(135,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(159,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(183,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(231,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(279,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(303,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(327,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(423,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(591,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(639,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(711,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(735,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(759,279) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(87,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(111,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(207,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(255,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(375,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(447,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(471,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(495,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(567,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(591,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(615,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(639,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(663,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(711,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(759,303) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(111,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(135,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(183,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(231,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(255,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(591,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(687,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(711,327) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(111,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(159,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(183,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(207,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(255,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(591,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(615,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(663,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(687,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(735,351) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(135,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(231,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(303,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(591,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(639,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(711,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(735,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(759,375) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(111,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(159,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(255,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(591,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(615,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(687,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(735,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(759,399) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(159,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(231,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(591,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(639,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(735,423) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(87,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(111,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(135,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(159,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(183,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(207,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(279,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(591,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(663,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(687,447) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(87,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(135,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(207,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(231,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(711,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(759,471) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(87,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(135,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(183,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(279,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(543,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(591,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(639,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(663,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(735,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(759,495) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(87,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(183,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(207,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(231,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(567,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(615,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(663,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(711,519) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(87,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(135,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(159,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(183,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(375,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(399,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(423,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(447,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(471,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(519,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(639,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(687,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(735,543) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(87,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(135,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(159,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(183,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(231,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(255,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(327,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(351,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(375,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(495,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(543,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(591,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(639,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(711,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(735,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(759,567) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(279,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(495,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(519,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(567,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(735,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(759,591) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(351,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(447,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(519,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(543,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(567,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(615,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,615) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(303,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(327,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(351,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(375,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(423,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(447,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(519,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(543,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(567,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(687,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(759,639) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(279,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(423,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(495,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(591,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(615,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(639,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(663,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(687,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(711,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(759,663) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(375,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(399,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(423,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(543,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(567,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(591,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(639,687) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(279,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(327,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(351,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(399,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(447,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(471,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(495,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(519,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(543,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(567,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(591,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(615,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(639,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(663,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(687,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(711,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(735,711) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(327,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(399,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(423,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(447,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(567,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(591,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(615,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(663,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(687,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(735,735) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(303,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(327,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(375,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(399,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(447,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(471,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(495,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(519,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(543,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(663,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(687,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(711,759) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(87,87)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(615,87)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87,615)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,135)",
    fill: "#922731"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(663,135)",
    fill: "#922731"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,663)",
    fill: "#922731"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDEyMDAgMTIyNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTIwMCAxMjI3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGQ9Ik02OTAuMyw1MzkuM2wzNTMuMS00MTAuNGgtODMuN0w2NTMuMSw0ODUuMkw0MDguMiwxMjguOEgxMjUuOGwzNzAuMyw1MzlsLTM3MC4zLDQzMC40aDgzLjdsMzIzLjgtMzc2LjNsMjU4LjYsMzc2LjNoMjgyLjQKCUw2OTAuMyw1MzkuM0w2OTAuMyw1MzkuM3ogTTU3NS43LDY3Mi41bC0zNy41LTUzLjZMMjM5LjUsMTkxLjloMTI4LjVMNjA5LDUzNi41bDM3LjUsNTMuNkw5NTkuNiwxMDM4SDgzMS4yTDU3NS43LDY3Mi41CglMNTc1LjcsNjcyLjV6Ii8+Cjwvc3ZnPgo=",
    width: 216,
    height: 216,
    x: 327,
    y: 327
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXQr);
export default __webpack_public_path__ + "static/media/xQR.22472195d3364ddeac03681774a998d4.svg";
export { ForwardRef as ReactComponent };